// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared clinical log form styles live in PatientLog/style.css (.cl-form). */
.follow-up-form-part {
  height: 100%;
  min-height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/MedicalTest/style.css"],"names":[],"mappings":"AAAA,6EAA6E;AAC7E;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":["/* Shared clinical log form styles live in PatientLog/style.css (.cl-form). */\n.follow-up-form-part {\n  height: 100%;\n  min-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
